import { Base } from '@/api/base'
import { TelephoneResponse } from '@/api/types'

export class Telephone extends Base {
  getTelephoneInformation() {
    return this.get<TelephoneResponse>('/resource/TelefoonNummerAlgemeen')
  }
}
